export const messages = {
  en: {
    inspectionPlan: {
      queryCondition: 'Query Conditions',
      inspectionPlanIdPlaceholder: 'Please enter plan ID',
      inspectionPlanNamePlaceholder: 'Please enter plan name',
      staffNamePlaceholder: 'Please enter inspector name',
      statePlaceholder: 'Please select status',
      query: 'Search',
      reset: 'Reset',
      inspectionPlanTitle: 'Inspection Plan (Updated at 2:00 AM)',
      add: 'Add',
      planName: 'Plan Name',
      planRoute: 'Plan Route',
      planCycle: 'Plan Cycle',
      signMethod: 'Sign-in Method',
      dateRange: 'Date Range',
      timeRange: 'Time Range',
      taskAdvance: 'Task Advance (minutes)',
      maker: 'Created By',
      createTime: 'Created Time',
      status: 'Status',
      inspectionStaff: 'Inspection Staff',
      operation: 'Operations',
      modify: 'Edit',
      delete: 'Delete',
      disable: 'Disable',
      enable: 'Enable',
      detail: 'Details',
      note: 'Please ensure the plan start and end times are valid and inspectors are assigned, otherwise inspection tasks cannot be generated.',
      fetchError: 'Failed to fetch inspection plans',
      confirmDeleteTitle: 'Confirm Deletion',
      confirmDeleteContent: 'Are you sure you want to delete this inspection plan?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      confirmOperation: 'Confirm Operation',
      confirmStateChange: 'Confirm State Change',
      
    },
    editInspectionPlan: {
      title: 'Edit Plan',
      planName: 'Plan Name',
      inspectionRoute: 'Inspection Route',
      inspectionPeriod: 'Inspection Period',
      taskAdvance: 'Task Advance',
      minutesGenerate: 'minutes generate',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      startDate: 'Start Date',
      endDate: 'End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      signMethod: 'Sign Method',
      allowRecheck: 'Allow Recheck',
      selectStaff: 'Select Staff',
      save: 'Save',
      back: 'Back',
      required: 'Required',
      monthlyDaily: 'Month/Day',
      weekly: 'Weekly',
      notAllowed: 'Not Allowed',
      allowed: 'Allowed',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  },
  zh: {
    inspectionPlan: {
      queryCondition: '查询条件',
      inspectionPlanIdPlaceholder: '请输入计划ID',
      inspectionPlanNamePlaceholder: '请输入计划名称',
      staffNamePlaceholder: '请输入巡检人',
      statePlaceholder: '请选择状态',
      query: '查询',
      reset: '重置',
      inspectionPlanTitle: '巡检计划(凌晨2点更新)',
      add: '添加',
      planName: '计划名称',
      planRoute: '计划路线',
      planCycle: '计划周期',
      signMethod: '签到方式',
      dateRange: '日期范围',
      timeRange: '时间范围',
      taskAdvance: '任务提前(分钟)',
      maker: '制定人',
      createTime: '制定时间',
      status: '状态',
      inspectionStaff: '巡检人员',
      operation: '操作',
      modify: '修改',
      delete: '删除',
      disable: '停用',
      enable: '启用',
      detail: '详情',
      note: '请确保计划开始时间和计划结束时间是有效时间范围，并且设置了巡检人，不然无法生成巡检任务',
      fetchError: '获取巡检计划失败',
      confirmDeleteTitle: '确认删除',
      confirmDeleteContent: '确定删除巡检计划吗？',
      cancel: '取消',
      confirm: '确定',
      confirmOperation: '确认操作',
      confirmStateChange: '确认状态变更',
    },
    editInspectionPlan: {
      title: '修改计划',
      planName: '计划名称',
      inspectionRoute: '巡检路线',
      inspectionPeriod: '巡检周期',
      taskAdvance: '任务提前',
      minutesGenerate: '分钟生成',
      month: '月',
      day: '日',
      week: '周',
      startDate: '开始日期',
      endDate: '结束日期',
      startTime: '开始时间',
      endTime: '结束时间',
      signMethod: '签到方式',
      allowRecheck: '允许补检',
      selectStaff: '选择员工',
      save: '保存',
      back: '返回',
      required: '必填',
      monthlyDaily: '月/天',
      weekly: '按周',
      notAllowed: '不允许补检',
      allowed: '允许补检',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日'
    }
  }
}